import React, { useEffect, useRef, useState } from "react";
import { Modal, Popconfirm, Tooltip } from "antd";
import { errorNotification } from "components/request-result";
import { Localize } from "components/service";


const confirmRemoveEntity = (props) => {
  const {
    variables,
    deleteMutation,
  } = props;

  let deleteVar;

  if (variables !== undefined)
  {
    deleteVar = { ...variables };
  } else
  {
    return false;
  }

  deleteMutation({
    variables: {
      ...deleteVar
    }

  }).catch((error) => {
    errorNotification(error);
  });
};

const EntityRemoveModal = (props) => {

  const [ showModal, setShowModal ] = useState(false);
  const {
    modalButton,
    loading,
    variables = {},
    deleteMutation = () => { },
    nameEntity,
    width = 380,
    dataNameEntity,
    text = false,
    disabled = false,
    okText = <Localize>GLOBAL.Button_Text_Delete</Localize>,
  } = props;


  const subText = <p><Localize deleteObjectType={ `${ nameEntity } ${ dataNameEntity } ` }>GLOBAL.Modal_Text_DeleteText</Localize></p>;

  return (
    <>
      { React.cloneElement(modalButton, {
        onClick: () => !disabled && setShowModal(true)
      }) }

      <Modal
        className="modal-standard modal-delete"
        open={ showModal }
        width={ width }
        onOk={
          () => {
            confirmRemoveEntity({
              variables,
              deleteMutation,
            });
            setShowModal(false);
          }
        }
        onCancel={ () => setShowModal(false) }
        okText={ okText }
        okButtonProps={
          {
            loading,
            className: ""
          }
        }
        cancelText={ <Localize>GLOBAL.Button_Text_Cancel</Localize> }
        cancelButtonProps={
          { className: "ant-btn-secondary" }
        }
      >
        { text ? text : subText }

      </Modal>
    </>
  );
};

const EntityRemovePopover = ({
  modalButton,
  loading = false,
  variables = {},
  deleteMutation,
  nameEntity,
  dataNameEntity,
  text = false,
  disabled = false,
  visible = true,
  tooltip,
  okText = <Localize>GLOBAL.Button_Text_Delete</Localize>,
}) => {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);
  const pendingRef = useRef(false);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    if (!visible) setOpen(false);
  }, [visible]);

  const confirm = async () => {
    if (pendingRef.current || loading || disabled || !visible) return;
    pendingRef.current = true;
    setPending(true);
    try {
      const result = await deleteMutation({ variables: { ...variables } });
      if (result !== false && mounted.current) setOpen(false);
    } catch (error) {
      errorNotification(error);
    } finally {
      pendingRef.current = false;
      if (mounted.current) setPending(false);
    }
  };

  const trigger = React.cloneElement(modalButton, {
    disabled: disabled || loading || pending || modalButton.props.disabled,
  });

  return (
    <Popconfirm
      open={visible && open}
      disabled={disabled || loading || pending || !visible}
      overlayClassName="app-settings-delete-popover"
      title={text || <Localize deleteObjectType={`${nameEntity} ${dataNameEntity} `}>GLOBAL.Modal_Text_DeleteText</Localize>}
      onOpenChange={(nextOpen) => {
        if (!pendingRef.current && !loading && !disabled) setOpen(nextOpen);
      }}
      // Control closing ourselves: Ant Design closes on every resolved Promise,
      // including a false result reported by a row after a failed mutation.
      onConfirm={() => { confirm(); }}
      onCancel={() => { if (!pendingRef.current) setOpen(false); }}
      okText={okText}
      cancelText={<Localize>GLOBAL.Button_Text_Cancel</Localize>}
      okButtonProps={{ danger: true, loading: loading || pending, disabled: loading || pending }}
      cancelButtonProps={{ disabled: loading || pending }}
    >
      {tooltip ? <Tooltip title={tooltip} open={visible && !open ? undefined : false}>{trigger}</Tooltip> : trigger}
    </Popconfirm>
  );
};

const EntityRemoveButton = ({ confirmation = "modal", ...props }) => confirmation === "popover"
  ? <EntityRemovePopover {...props} />
  : <EntityRemoveModal {...props} />;

export default EntityRemoveButton;
